/**
 * CL-397C — Sale prep route (seller journey; not Search).
 */

export const SALE_PREP_ROUTE = "/client-portal/real-estate/sale-prep";

export const SALE_PREP_TITLE = "Sale prep";
export const SALE_PREP_INTRO =
  "Starter checklist for sellers preparing to list. Property files, documents, and CMA live in My Properties — this page is your seller-readiness anchor.";
